import { render, staticRenderFns } from "./StatisticsTable.vue?vue&type=template&id=0ca0c578"
import script from "./StatisticsTable.vue?vue&type=script&lang=js"
export * from "./StatisticsTable.vue?vue&type=script&lang=js"
import style0 from "./StatisticsTable.vue?vue&type=style&index=0&id=0ca0c578&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports